import React from "react";
import { sponsorInfo } from "../data/mock";
import { useReveal } from "../hooks/useReveal";
import { Heart, Star, Trophy } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

export default function Sponsor() {
  const { t } = useLanguage();
  const r = useReveal();

  return (
    <section id="sponsor" className="py-24 relative overflow-hidden bg-charcoal">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-10 left-10 w-72 h-72 rounded-full bg-[#7A1F1F]/40 blur-3xl" />
        <div className="absolute bottom-10 right-10 w-72 h-72 rounded-full bg-[#E86D1F]/20 blur-3xl" />
      </div>

      <div className="max-w-6xl mx-auto px-6 relative">
        <div ref={r.ref} className={`reveal ${r.visible ? "in" : ""} text-center mb-10`}>
          <p className="section-sub text-[#E9C97A]">{t.sponsor.sub}</p>
          <h2 className="font-display text-4xl md:text-6xl mt-3 text-[#FFF7EA] font-bold">
            {t.sponsor.titlePre}<span className="text-[#E86D1F]">{t.sponsor.titleHi}</span>{t.sponsor.titlePost}
          </h2>
          <div className="ornament mt-4">
            <Trophy className="text-[#D4A94A]" size={22} />
          </div>
        </div>

        <div className={`sponsor-frame p-8 md:p-14 grid lg:grid-cols-2 gap-10 items-center reveal ${r.visible ? "in" : ""}`} style={{ transitionDelay: "0.2s" }}>
          <div className="relative flex items-center justify-center">
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="w-72 h-72 md:w-96 md:h-96 rounded-full border-2 border-[#D4A94A]/30 spin-slow" />
              <div className="absolute w-56 h-56 md:w-80 md:h-80 rounded-full border border-[#D4A94A]/20 spin-slow" style={{ animationDirection: "reverse" }} />
            </div>
            <img
              src={sponsorInfo.image}
              alt="SC Weiche Flensburg von 1908 Sponsor Badge"
              className="relative z-10 w-64 md:w-80 rounded-lg shadow-2xl float"
              style={{ boxShadow: "0 20px 60px rgba(0,0,0,0.6), 0 0 40px rgba(212,169,74,0.3)" }}
            />
          </div>

          <div>
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#E86D1F] text-white text-xs font-semibold tracking-widest uppercase">
              <Star size={14} /> {t.sponsor.badge}
            </div>
            <h3 className="font-display text-3xl md:text-4xl mt-5 text-[#FFF7EA] font-bold leading-tight">
              {t.sponsor.headline}<span className="text-[#D4A94A]">{t.sponsor.headlineHi}</span>
            </h3>
            <p className="mt-5 text-[#FBEFD9]/85 leading-relaxed text-base md:text-lg">
              {t.sponsor.desc}
            </p>

            <div className="mt-8 grid grid-cols-3 gap-4">
              {[
                { icon: Heart, label: t.sponsor.values[0] },
                { icon: Trophy, label: t.sponsor.values[1] },
                { icon: Star, label: t.sponsor.values[2] },
              ].map((v, i) => (
                <div key={i} className="text-center p-4 rounded-lg bg-[#1B1512]/40 border border-[#D4A94A]/20 hover:border-[#D4A94A]/60 transition-colors">
                  <v.icon className="text-[#E86D1F] mx-auto" size={22} />
                  <p className="mt-2 text-[#FBEFD9] text-sm font-semibold tracking-wide">{v.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-10 overflow-hidden py-3 border-y border-[#D4A94A]/20">
          <div className="flex gap-12 whitespace-nowrap" style={{ animation: "marquee 25s linear infinite" }}>
            {[...Array(2)].flatMap((_, k) => [
              <span key={`a-${k}`} className="font-display text-[#D4A94A]/80 tracking-[0.4em] text-sm">❀ {t.sponsor.badge.toUpperCase()} · SC WEICHE FLENSBURG VON 1908</span>,
              <span key={`b-${k}`} className="font-display text-[#E86D1F]/80 tracking-[0.4em] text-sm">❀ PURI PURI FLENSBURG</span>,
              <span key={`c-${k}`} className="font-display text-[#D4A94A]/80 tracking-[0.4em] text-sm">❀ {t.sponsor.headlineHi.toUpperCase()}</span>,
              <span key={`d-${k}`} className="font-display text-[#E86D1F]/80 tracking-[0.4em] text-sm">❀ {t.hero.slides[3].title.toUpperCase()}</span>,
            ])}
          </div>
        </div>
      </div>
      <style>{`@keyframes marquee { from { transform: translateX(0);} to { transform: translateX(-50%);} }`}</style>
    </section>
  );
}
